export const isClientStatusCode = (statusCode: number | undefined | null): boolean => {
	if (!statusCode) return false;
	return statusCode >= 400 && statusCode < 500;
};
